import React from 'react';
import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

export const Container = ({ children, className = '' }) => (
  <div className={`max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 ${className}`}>{children}</div>
);

export const Reveal = ({ children, delay = 0, className = '', ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = '' }) => (
  <p className={`text-[11px] font-mono uppercase tracking-[0.22em] text-content-3 ${className}`}>{children}</p>
);

export const SectionHeader = ({ eyebrow, title, subtitle, action }) => (
  <Reveal className="grid lg:grid-cols-12 gap-6 lg:gap-10 items-end">
    <div className="lg:col-span-7">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-heading font-medium tracking-tight leading-[1.08] text-content">
        {title}
      </h2>
    </div>
    {(subtitle || action) && (
      <div className="lg:col-span-4 lg:col-start-9 flex flex-col gap-5 lg:pb-1">
        {subtitle && <p className="text-content-2 text-base leading-relaxed">{subtitle}</p>}
        {action}
      </div>
    )}
  </Reveal>
);

export const Btn = ({ variant = 'primary', className = '', children, ...props }) => {
  const base = 'group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-medium transition-[background-color,border-color,opacity,transform] duration-300 active:scale-[0.98]';
  const styles = variant === 'primary'
    ? 'bg-btn text-btn-foreground hover:opacity-90'
    : 'border border-line-2 text-content hover:bg-overlay-hover';
  return (
    <button className={`${base} ${styles} ${className}`} {...props}>{children}</button>
  );
};
